// extracted by mini-css-extract-plugin
module.exports = {"row":"RatingList_row__2Ba-F","optionText":"RatingList_optionText__3OAwm"};